import { Component } from 'base/js/aem';
import { defineCustomElement } from 'vue';
import Modal from 'base/js/templates/customElements/Modal.ce.vue';

// Register the amd-modal element (only needed once since it's global).
const amdModal = defineCustomElement(Modal, { shadowRoot: false });
customElements.define('amd-modal', amdModal);

class simpleModal extends Component {
    init() {
        this.openButton = this.element.querySelector('[data-function="open-modal"]');
        this.amdModalEl = this.element.querySelector('amd-modal');
        this.card = this.element.querySelector('.card');
        this.initSimpleModal();
    }

    handleEvent(e) {
        switch (e.type) {
        case 'click':
            this.openDialog();
            break;
        case 'dialog-closed':
            this.dialogClosed();
            break;
        default:
            break;
        }
    }

    initSimpleModal() {
        this.card.addEventListener('click', this);
        this.amdModalEl.addEventListener('dialog-closed', this);
    }

    /**
     * Open the dialog. Gets the Vue instance of the custom element and calls the openDialog method from the list of
     * exposed methods in the Vue template.
     */
    openDialog() {
        this.amdModalEl.setAttribute('open', true);
    }

    /**
     * Remove the open attribute when the dialog has been closed.
     */
    dialogClosed() {
        window.setTimeout(() => this.openButton.blur(), 700);
        this.amdModalEl.removeAttribute('open');
    }
}

export { simpleModal };
